interface AerialIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const AerialIcon = (props: AerialIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <g>
        <g>
          <g>
            <g>
              <g>
                <path
                  style={{ fill: fillColor }}
                  d="M17.6,29c-0.1,0-0.3-0.1-0.3-0.2c-0.5-1.1-1.6-2-3-3.1C12,23.9,9.1,21.6,8.5,17c-0.4-2.7,0.5-5.3,2.3-7.5
                    C13.2,7,16.5,5.4,20,5.4c0.2,0,0.4,0.2,0.4,0.4S20.2,6.2,20,6.2c-3.2,0-6.5,1.4-8.6,3.9c-1.7,2-2.5,4.5-2.2,6.9
                    c0.5,4.3,3.2,6.5,5.6,8.3c1.3,1.1,2.6,2.1,3.1,3.3C17.9,28.7,17.8,28.9,17.6,29C17.7,29,17.6,29,17.6,29z"
                />
                <path
                  style={{ fill: fillColor }}
                  d="M17.6,29.1c-0.2,0-0.3-0.1-0.4-0.3c-0.4-1.1-1.6-2-3-3.1C11.9,23.9,9,21.6,8.4,17
                    c-0.4-2.7,0.5-5.3,2.4-7.5C13.1,7,16.5,5.4,20,5.4c0.3,0,0.4,0.2,0.4,0.4c0,0.3-0.2,0.4-0.4,0.4c-3.2,0-6.5,1.4-8.5,3.9
                    c-1.7,2-2.5,4.4-2.2,6.8c0.5,4.3,3.2,6.4,5.5,8.3c1.3,1.1,2.6,2.1,3.1,3.3c0.1,0.2,0,0.4-0.2,0.5
                    C17.7,29.1,17.7,29.1,17.6,29.1z M20,5.5c-3.4,0-6.8,1.5-9.1,4c-1.9,2.2-2.7,4.8-2.3,7.4c0.6,4.6,3.5,6.8,5.7,8.7
                    c1.3,1.1,2.4,2,3,3.1c0.1,0.1,0.2,0.2,0.4,0.1c0.1-0.1,0.2-0.2,0.1-0.4c-0.5-1.3-1.7-2.2-3.1-3.3c-2.3-1.9-5-4-5.6-8.4
                    c-0.3-2.3,0.5-4.8,2.2-6.8c2.2-2.4,5.4-3.9,8.7-3.9c0.2,0,0.3-0.1,0.3-0.3C20.3,5.7,20.2,5.5,20,5.5z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  style={{ fill: fillColor }}
                  d="M22.4,29c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.3-0.3-0.2-0.4c0.5-1.3,1.8-2.2,3.1-3.3c2.3-1.9,4.9-4,5.6-8.3
                    c0.4-2.4-0.4-4.9-2.2-6.9c-2.2-2.4-5.3-3.9-8.6-3.9c-0.2,0-0.4-0.2-0.4-0.4c0.1-0.2,0.3-0.4,0.4-0.4c3.5,0,6.8,1.5,9.2,4.1
                    c1.9,2.2,2.7,4.8,2.3,7.5c-0.6,4.6-3.5,6.9-5.8,8.7c-1.3,1.1-2.4,2-3,3.1C22.7,29,22.6,29,22.4,29z"
                />
                <path
                  style={{ fill: fillColor }}
                  d="M22.4,29.1c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.3-0.4-0.2-0.5c0.5-1.3,1.8-2.2,3.1-3.3c2.3-1.9,4.9-4,5.5-8.3
                    c0.4-2.4-0.4-4.9-2.2-6.8c-2.1-2.4-5.3-3.9-8.5-3.9c-0.3,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c3.5,0,6.9,1.5,9.2,4.1
                    c1.9,2.2,2.8,4.9,2.4,7.5c-0.6,4.6-3.5,6.9-5.8,8.8c-1.3,1.1-2.4,2-3,3.1C22.8,29,22.6,29.1,22.4,29.1z M20,5.5
                    c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3c3.3,0,6.6,1.4,8.7,3.9c1.8,2,2.5,4.5,2.2,7c-0.5,4.3-3.2,6.5-5.6,8.4
                    c-1.3,1.1-2.6,2.1-3.1,3.3c-0.1,0.1,0,0.3,0.1,0.4s0.3,0,0.4-0.1c0.5-1.2,1.6-2.1,3-3.1c2.3-1.8,5.2-4.1,5.7-8.7
                    c0.4-2.6-0.4-5.2-2.3-7.4C26.8,7.1,23.4,5.5,20,5.5z"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  style={{ fill: fillColor }}
                  d="M18.2,28.7c-0.2,0-0.3-0.1-0.4-0.2c-0.4-1-1.1-1.8-1.9-2.8c-1.6-1.9-3.6-4.1-4-8.7c-0.3-3.3,0.7-6.7,2.9-9
                    c1.4-1.7,3.3-2.6,5.1-2.6c0.2,0,0.4,0.2,0.4,0.4S20.2,6.2,20,6.2c-1.6,0-3.3,0.8-4.7,2.3c-2,2.2-3,5.3-2.7,8.5
                    c0.4,4.3,2.2,6.5,3.8,8.4c0.8,1,1.6,1.9,2.1,3C18.6,28.5,18.5,28.7,18.2,28.7C18.3,28.7,18.3,28.7,18.2,28.7z"
                />
                <path
                  style={{ fill: fillColor }}
                  d="M18.2,28.8c-0.2,0-0.4-0.1-0.4-0.3c-0.4-1-1.1-1.8-1.9-2.8c-1.6-1.9-3.6-4.1-4-8.7
                    c-0.3-3.4,0.7-6.7,2.9-9.1c1.4-1.6,3.2-2.5,5.1-2.5c0.3,0,0.4,0.2,0.4,0.4c0,0.3-0.2,0.4-0.4,0.4c-1.6,0-3.2,0.8-4.6,2.2
                    c-2,2.2-3,5.3-2.6,8.4c0.4,4.3,2.2,6.5,3.8,8.3c0.8,1,1.6,1.9,2.1,3.1c0.1,0.2,0,0.4-0.3,0.5C18.3,28.8,18.3,28.8,18.2,28.8z
                     M20,5.5c-1.8,0-3.6,0.9-5.1,2.5c-2.1,2.2-3.1,5.6-2.8,9c0.4,4.6,2.3,6.8,4,8.6c0.8,1,1.5,1.8,2,2.8c0.1,0.1,0.2,0.2,0.4,0.2
                    c0.1-0.1,0.2-0.2,0.2-0.4c-0.4-1.1-1.2-2-2.1-3c-1.6-1.9-3.4-4-3.9-8.4c-0.3-3.2,0.7-6.4,2.7-8.5c1.3-1.5,3.1-2.3,4.7-2.3
                    c0.2,0,0.3-0.1,0.3-0.3C20.3,5.7,20.2,5.5,20,5.5z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  style={{ fill: fillColor }}
                  d="M21.8,28.7L21.8,28.7c-0.3-0.1-0.4-0.3-0.3-0.4c0.4-1.1,1.2-2.1,2.1-3c1.6-1.9,3.4-4,3.8-8.4
                    c0.3-3.1-0.7-6.4-2.7-8.5c-1.3-1.4-3-2.3-4.7-2.3c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0.2-0.3,0.4-0.3c1.8,0,3.7,0.9,5.1,2.5
                    c2.1,2.2,3.1,5.7,2.9,9c-0.4,4.6-2.4,6.8-4,8.7c-0.8,1-1.5,1.8-1.9,2.8C22.1,28.6,21.9,28.7,21.8,28.7z"
                />
                <path
                  style={{ fill: fillColor }}
                  d="M21.8,28.8c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.4-0.4-0.3-0.5c0.4-1.1,1.3-2.1,2.1-3.1c1.6-1.9,3.4-4,3.8-8.3
                    c0.3-3.1-0.7-6.3-2.6-8.4c-1.3-1.4-3-2.2-4.6-2.2c-0.3,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c1.9,0,3.7,0.9,5.2,2.5
                    c2.1,2.3,3.1,5.7,2.9,9.1c-0.4,4.6-2.4,6.9-4,8.7c-0.8,1-1.5,1.8-1.9,2.8C22.1,28.7,22,28.8,21.8,28.8z M20,5.5
                    c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3c1.7,0,3.3,0.8,4.7,2.3c2,2.2,3,5.4,2.7,8.5c-0.4,4.4-2.2,6.5-3.9,8.4
                    c-0.8,1-1.6,1.9-2.1,3c-0.1,0.1,0,0.3,0.2,0.4c0.1,0.1,0.3,0,0.4-0.2c0.4-1,1.1-1.9,2-2.8c1.6-1.8,3.5-4.1,4-8.6
                    c0.3-3.3-0.7-6.6-2.8-9C23.6,6.4,21.8,5.5,20,5.5z"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  style={{ fill: fillColor }}
                  d="M19.4,28.5c-0.2,0-0.3-0.1-0.4-0.3c-0.2-1-0.4-1.7-0.7-2.7c-0.5-1.8-1.3-4.1-1.4-8.6
                    c-0.2-4.9,0.7-9.6,2.2-11c0.4-0.3,0.6-0.4,1-0.4c0.2,0,0.4,0.2,0.4,0.4S20.2,6.2,20,6.2c-0.2,0-0.3,0.1-0.4,0.3
                    c-1.3,1.4-2.1,6.5-2,10.5c0.2,4.4,0.8,6.6,1.3,8.4c0.3,0.9,0.5,1.8,0.7,2.8C19.7,28.3,19.6,28.5,19.4,28.5L19.4,28.5z"
                />
                <path
                  style={{ fill: fillColor }}
                  d="M19.4,28.6c-0.2,0-0.4-0.2-0.4-0.4c-0.2-1-0.4-1.7-0.7-2.7c-0.5-1.8-1.3-4.1-1.4-8.6
                    c-0.2-4.9,0.7-9.6,2.2-11c0.4-0.4,0.7-0.4,1.1-0.4c0.3,0,0.4,0.2,0.4,0.4c0,0.3-0.2,0.4-0.4,0.4c-0.1,0-0.3,0.1-0.4,0.3
                    c-1.3,1.4-2.1,6.5-1.9,10.5c0.2,4.4,0.8,6.6,1.3,8.4c0.3,0.9,0.5,1.8,0.7,2.8c0,0.1,0,0.2-0.1,0.3
                    C19.6,28.5,19.6,28.6,19.4,28.6L19.4,28.6z M20,5.5c-0.3,0-0.6,0.2-0.9,0.4c-1.3,1.4-2.2,6-2.2,11c0.2,4.5,0.8,6.7,1.4,8.6
                    c0.3,0.9,0.5,1.7,0.7,2.7c0,0.2,0.2,0.3,0.3,0.2c0.1,0,0.1-0.1,0.2-0.1c0-0.1,0.1-0.1,0.1-0.2c-0.2-1-0.4-1.9-0.7-2.8
                    c-0.6-1.9-1.3-4-1.4-8.4c-0.1-4,0.6-9.2,2-10.6c0.2-0.2,0.4-0.3,0.5-0.3s0.3-0.1,0.3-0.3C20.3,5.7,20.2,5.5,20,5.5z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  style={{ fill: fillColor }}
                  d="M20.6,28.5L20.6,28.5c-0.3,0-0.4-0.2-0.4-0.4c0.2-1,0.4-1.9,0.7-2.8c0.5-1.9,1.3-4,1.3-8.4
                    c0.1-4-0.5-9.1-2-10.5c-0.2-0.2-0.4-0.3-0.4-0.3c-0.2,0-0.4-0.2-0.4-0.4c0.1-0.2,0.3-0.4,0.4-0.4c0.4,0,0.6,0.2,1,0.4
                    c1.4,1.4,2.3,6.1,2.2,11c-0.2,4.5-0.8,6.7-1.4,8.6c-0.3,0.9-0.5,1.7-0.7,2.7C21,28.4,20.8,28.5,20.6,28.5z"
                />
                <path
                  style={{ fill: fillColor }}
                  d="M20.6,28.6L20.6,28.6c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.1-0.2-0.1-0.3c0.2-1,0.4-1.9,0.7-2.8
                    c0.5-1.9,1.3-4,1.3-8.4c0.1-4-0.5-9.1-1.9-10.5c-0.1-0.1-0.3-0.2-0.4-0.2c-0.3,0-0.4-0.2-0.4-0.4c0-0.2,0.3-0.4,0.4-0.4
                    c0.4,0,0.7,0.2,1,0.5c1.4,1.4,2.3,6.1,2.2,11c-0.2,4.5-0.9,6.8-1.4,8.6c-0.3,0.9-0.5,1.7-0.7,2.7
                    C21.1,28.4,20.9,28.6,20.6,28.6z M20,5.5c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3s0.4,0.1,0.5,0.3c1.4,1.4,2.1,6.6,2,10.6
                    c-0.2,4.4-0.8,6.6-1.4,8.4c-0.3,0.9-0.5,1.8-0.7,2.8c0,0.1,0,0.2,0.1,0.2c0,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.2
                    c0.2-1,0.4-1.8,0.7-2.7c0.5-1.8,1.3-4.1,1.4-8.6c0.2-4.9-0.7-9.5-2.2-11C20.6,5.7,20.4,5.5,20,5.5z"
                />
              </g>
            </g>
          </g>
          <g>
            <path
              style={{ fill: fillColor }}
              d="M20,29.5c-1.1,0-2.8-0.1-2.8-0.8c0-0.4,0.7-0.6,1-0.6C18.7,28,19.3,28,20,28s1.3,0,1.8,0.1
                c0.3,0.1,1,0.2,1,0.6C22.8,29.4,21.1,29.5,20,29.5z M18.3,28.7c0.4,0.1,0.9,0.2,1.7,0.2c0.7,0,1.3-0.1,1.7-0.2
                c-0.4-0.1-0.9-0.1-1.7-0.1C19.3,28.6,18.7,28.6,18.3,28.7z"
            />
            <path
              style={{ fill: fillColor }}
              d="M20,29.6c-1.3,0-2.9-0.2-2.9-0.9c0-0.5,0.7-0.7,1.1-0.7c0.4-0.1,1.1-0.1,1.8-0.1s1.3,0,1.8,0.1
                c0.4,0.1,1.1,0.2,1.1,0.7C22.9,29.4,21.3,29.6,20,29.6z M20,28c-0.7,0-1.3,0-1.8,0.1c-0.3,0.1-0.9,0.2-0.9,0.5
                c0,0.4,1,0.7,2.7,0.7s2.7-0.3,2.7-0.7s-0.6-0.5-0.9-0.5C21.3,28,20.7,28,20,28z M20,28.9c-0.9,0-1.4-0.1-1.7-0.2l-0.4-0.1
                l0.4-0.1c0.3-0.1,0.8-0.1,1.7-0.1c0.8,0,1.3,0.1,1.7,0.1l0.4,0.1l-0.4,0.2C21.4,28.8,20.9,28.9,20,28.9z M18.9,28.7
                c0.3,0,0.6,0.1,1.1,0.1s0.8,0,1.1-0.1c-0.3,0-0.6,0-1.1,0S19.2,28.7,18.9,28.7z"
            />
          </g>
          <g>
            <path
              style={{ fill: fillColor }}
              d="M30.7,19.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.1-0.4-0.5-3.1-0.9c-2-0.3-4.5-0.4-7.3-0.4c-2.7,0-5.3,0.2-7.3,0.4
                C10,18.5,9.7,18.9,9.7,19c0,0.2-0.2,0.4-0.4,0.4S9,19.2,9,19c0-0.4,0.4-1,3.4-1.5c2.1-0.3,4.8-0.4,7.6-0.4s5.6,0.2,7.6,0.4
                c3.1,0.4,3.4,1.1,3.4,1.5C31,19.2,30.9,19.4,30.7,19.4z"
            />
            <path
              style={{ fill: fillColor }}
              d="M30.7,19.5c-0.2,0-0.4-0.2-0.4-0.4c-0.1-0.1-0.5-0.4-3.1-0.8c-2-0.3-4.5-0.4-7.2-0.4s-5.3,0.2-7.2,0.4
                c-2.4,0.4-3,0.7-3.1,0.8c0,0.2-0.2,0.4-0.4,0.4S8.9,19.3,8.9,19c0-0.5,0.4-1.1,3.5-1.5c2.1-0.3,4.8-0.4,7.6-0.4s5.6,0.2,7.6,0.4
                c3.1,0.4,3.5,1.1,3.5,1.5C31,19.3,30.9,19.5,30.7,19.5z M20,17.7c2.7,0,5.3,0.2,7.3,0.4c2.7,0.4,3.1,0.8,3.1,0.9l0,0l0,0
                c0,0.2,0.1,0.3,0.3,0.3c0.2,0,0.3-0.1,0.3-0.3c0-0.4-0.4-1-3.3-1.4c-2.1-0.3-4.8-0.4-7.6-0.4s-5.6,0.2-7.5,0.4
                c-3,0.4-3.3,1-3.3,1.4c0,0.2,0.1,0.3,0.3,0.3c0.2,0,0.3-0.1,0.3-0.3l0,0l0,0c0.1-0.1,0.4-0.5,3.1-0.9
                C14.7,17.7,17.3,17.7,20,17.7z"
            />
          </g>
          <g>
            <path
              style={{ fill: fillColor }}
              d="M28.5,23c-0.2,0-0.4-0.2-0.4-0.4c-0.1-0.1-0.6-0.4-2.4-0.8c-1.5-0.3-3.6-0.4-5.7-0.4s-4.1,0.2-5.7,0.4
                c-1.8,0.3-2.3,0.6-2.4,0.8c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.4,0.3-1,2.8-1.3c1.6-0.3,3.8-0.4,6-0.4
                s4.4,0.2,6,0.4c2.5,0.4,2.8,1,2.8,1.3C28.8,22.9,28.7,23,28.5,23z"
            />
            <path
              style={{ fill: fillColor }}
              d="M28.5,23c-0.2,0-0.4-0.2-0.4-0.4c-0.1-0.1-0.6-0.4-2.3-0.7c-1.5-0.3-3.6-0.4-5.7-0.4s-4.1,0.2-5.7,0.4
                c-1.7,0.3-2.2,0.6-2.3,0.7c0,0.2-0.2,0.4-0.4,0.4S11,22.9,11,22.6c0-0.4,0.4-1,2.9-1.4c1.6-0.3,3.8-0.4,6.1-0.4s4.5,0.2,6.1,0.4
                c2.5,0.4,2.9,1,2.9,1.4C28.9,22.9,28.7,23,28.5,23z M20,21.4c2.2,0,4.1,0.2,5.7,0.4c1.8,0.3,2.4,0.6,2.5,0.8l0,0l0,0
                c0,0.2,0.1,0.3,0.3,0.3c0.2,0,0.3-0.1,0.3-0.3c0-0.2,0-0.8-2.7-1.3c-1.6-0.3-3.8-0.4-6-0.4s-4.4,0.2-6,0.4
                c-2.7,0.4-2.7,1.1-2.7,1.3c0,0.2,0.1,0.3,0.3,0.3c0.2,0,0.3-0.1,0.3-0.3l0,0l0,0c0.1-0.2,0.7-0.5,2.5-0.8
                C15.9,21.6,17.8,21.4,20,21.4z"
            />
          </g>
          <g>
            <g>
              <path
                style={{ fill: fillColor }}
                d="M21.7,34.7h-3.3c-0.6,0-1.1-0.4-1.1-1.1V31c0-0.2,0.2-0.4,0.4-0.4h4.9c0.2,0,0.4,0.2,0.4,0.4v2.6
                  C22.8,34.3,22.2,34.7,21.7,34.7z M17.9,31.4v2.2c0,0.3,0.2,0.4,0.4,0.4h3.3c0.3,0,0.4-0.2,0.4-0.4v-2.2H17.9z"
              />
              <path
                style={{ fill: fillColor }}
                d="M21.7,34.8h-3.3c-0.6,0-1.2-0.5-1.2-1.2V31c0-0.3,0.2-0.4,0.4-0.4h4.9c0.3,0,0.4,0.2,0.4,0.4v2.6
                  C22.9,34.3,22.3,34.8,21.7,34.8z M17.6,30.8c-0.2,0-0.3,0.1-0.3,0.3v2.6c0,0.5,0.4,1,1,1h3.3c0.5,0,1-0.4,1-1V31
                  c0-0.2-0.1-0.3-0.3-0.3H17.6z M21.7,34.1h-3.3c-0.3,0-0.5-0.2-0.5-0.5v-2.3h4.3v2.3C22.2,33.9,22,34.1,21.7,34.1z M18,31.5v2.2
                  c0,0.2,0.2,0.4,0.4,0.4h3.3c0.2,0,0.4-0.2,0.4-0.4v-2.2H18z"
              />
            </g>
            <g>
              <path
                style={{ fill: fillColor }}
                d="M20.6,34.7h-1.2c-0.4,0-0.6-0.4-0.6-1.1V31c0-0.2,0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4v2.6
                  C21.2,34.3,21,34.7,20.6,34.7z M19.6,34.1h1c0-0.1,0.1-0.2,0.1-0.4v-2.2h-1.1v2.2C19.5,33.8,19.5,34,19.6,34.1z"
              />
              <path
                style={{ fill: fillColor }}
                d="M20.6,34.8h-1.2c-0.4,0-0.7-0.4-0.7-1.2V31c0-0.3,0.2-0.4,0.4-0.4h1.7c0.3,0,0.4,0.2,0.4,0.4v2.6
                  C21.3,34.4,21,34.8,20.6,34.8z M19.1,30.8c-0.2,0-0.3,0.1-0.3,0.3v2.6c0,0.6,0.2,1,0.5,1h1.2c0.4,0,0.5-0.4,0.5-1V31
                  c0-0.2-0.1-0.3-0.3-0.3H19.1z M20.5,34.1h-1.1V34c0-0.1-0.1-0.2-0.1-0.4v-2.3h1.3v2.3C20.6,33.9,20.5,34,20.5,34.1L20.5,34.1z
                   M19.6,34h0.8c0-0.1,0-0.2,0-0.4v-2.2h-0.9v2.2C19.6,33.8,19.6,33.9,19.6,34z"
              />
            </g>
          </g>
          <g>
            <path
              style={{ fill: fillColor }}
              d="M17.6,31.4c-0.2,0-0.4-0.2-0.4-0.4v-2.3c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4V31
                C17.9,31.2,17.8,31.4,17.6,31.4z"
            />
            <path
              style={{ fill: fillColor }}
              d="M17.6,31.5c-0.3,0-0.4-0.2-0.4-0.4v-2.3c0-0.3,0.2-0.4,0.4-0.4c0.3,0,0.4,0.2,0.4,0.4V31
                C18,31.3,17.8,31.5,17.6,31.5z M17.6,28.4c-0.2,0-0.3,0.1-0.3,0.3V31c0,0.2,0.1,0.3,0.3,0.3s0.3-0.1,0.3-0.3v-2.3
                C17.8,28.5,17.7,28.4,17.6,28.4z"
            />
          </g>
          <g>
            <path
              style={{ fill: fillColor }}
              d="M22.4,31.4c-0.2,0-0.4-0.2-0.4-0.4v-2.3c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4V31
                C22.8,31.2,22.6,31.4,22.4,31.4z"
            />
            <path
              style={{ fill: fillColor }}
              d="M22.4,31.5c-0.3,0-0.4-0.2-0.4-0.4v-2.3c0-0.3,0.2-0.4,0.4-0.4c0.3,0,0.4,0.2,0.4,0.4V31
                C22.9,31.3,22.7,31.5,22.4,31.5z M22.4,28.4c-0.2,0-0.3,0.1-0.3,0.3V31c0,0.2,0.1,0.3,0.3,0.3c0.2,0,0.3-0.1,0.3-0.3v-2.3
                C22.7,28.5,22.6,28.4,22.4,28.4z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default AerialIcon
